import { render, staticRenderFns } from "./WatchRecording.vue?vue&type=template&id=c432da20&scoped=true&"
import script from "./WatchRecording.vue?vue&type=script&lang=js&"
export * from "./WatchRecording.vue?vue&type=script&lang=js&"
import style0 from "./WatchRecording.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WatchRecording.vue?vue&type=style&index=1&id=c432da20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c432da20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCarousel,VCarouselItem,VChip,VCol,VImg,VRow})
